import React, { useState, useEffect } from "react";
import "./styles/About.css";
import AboutCard from "../components/AboutCard.jsx";
import Navbar from "../components/Navbar.jsx";
import Footer from "../sections/Footer.jsx";
import { motion } from "framer-motion";

const About = () => {
  const [count, setCount] = useState(0);

  // Scroll to the top when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
    const dayOfWeek = new Date().getDay(); // 0 (Sunday) to 6 (Saturday)
    setCount(dayOfWeek);
  }, []);

  const targetStats = {
    coffees: count * 5,
    creatine: count * 12, // in grams
    gingerShots: count * 2,
    trainingMinutes: count * 4 * 60,
  };

  const [stats, setStats] = useState({
    coffees: 0,
    creatine: 0,
    gingerShots: 0,
    trainingMinutes: 0,
  });

  // Animate each stat from 0 to its target value
  useEffect(() => {
    const interval = setInterval(() => {
      setStats((prev) => {
        const updated = { ...prev };
        let changed = false;

        Object.keys(targetStats).forEach((key) => {
          if (prev[key] < targetStats[key]) {
            updated[key] += 1;
            changed = true;
          } else if (prev[key] === targetStats[key]) {
            if (key === 'trainingMinutes' && count > 2) {
              updated[key] = 'a lot'; // to avoid infinite loop
            }
          }
        });
        if (!changed) {
          clearInterval(interval);
        }
        return updated;
      });
    }, 30); // adjust speed here

    return () => clearInterval(interval);
  }, [count]);

  return (
    <div className="about">
      <Navbar pageOn={"about"} />
      <div className="about__container">
        <div>
          <AboutCard
            headerContent={"Creating community through movement"}
            imageType={"about1"}
            rowType={"row-reverse"}
          >
            <p>
              At newro, we believe in the power of movement to bring people
              together. We're creating a community where humans (and pets) can connect,
              explore, and grow together through shared experiences both in nature and beyond.
              <br />
              <br />
              Founded by two lifelong friends with a shared love for training, movement, and all things
              active, our platform simplifies the search for movement-based activities—whether you're
              scaling trails, flowing through park yoga, or just looking for an excuse to wear your
              activewear outside.
            </p>
          </AboutCard>
        </div>

        {/* Big Text  */}
        <motion.div
          className="about__main--text"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          Physical movement has always been more than just exercise for us—it's been a lifeline.
          Throughout our lives, staying active has helped us navigate stress, build confidence,
          and find clarity in challenging times. It's how we've stayed mentally grounded and emotionally
          balanced. Just as importantly, movement has been the spark for countless friendships,
          meaningful conversations, and shared experiences that brought us closer to others and
          to ourselves. For us, it's not optional—it's essential. That's why we're so passionate
          about sharing this experience with the world—helping others discover what movement
          has so generously given us.
        </motion.div>

        {/* Stats */}

        <div className="about__stats--outer-container">
          <h2> This week at Newro </h2>
          <div className="about__stats--container">
            <div className="about__stats--field">
              <h3> {stats.coffees} </h3>
              <p> Coffees </p>
            </div>
            <div className="about__stats--field">
              <h3> {stats.creatine} </h3>
              <p> Creatine (grams) </p>
            </div>
            <div className="about__stats--field">
              <h3> {stats.gingerShots} </h3>
              <p> Ginger shots </p>
            </div>
            <div className="about__stats--field">
              <h3> {stats.trainingMinutes} </h3>
              <p>Minutes spent training </p>
            </div>

          </div>
        </div>

        {/* Our Mission */}
        <div>
          <AboutCard
            headerContent={"Our Mission"}
            imageType={"about2"}
            rowType={"row"}
          >
            <p>
              We're building more than just a digital platform—we're creating a movement.
              <br />
              <br />
              By offering a space where anyone can host or join activity-based
              events and easily connect with like-minded people nearby, we aim to
              make movement more accessible, social, and meaningful.
            </p>
            <ul>
              <li>Foster real-world connections through shared physical activity</li>
              <li>Celebrate the outdoors as a space for growth, wellness, and community</li>
            </ul>
          </AboutCard>
        </div>

        {/* Our Vision */}
        <div>
          <AboutCard
            headerContent={"Our Vision"}
            imageType={"about3"}
            rowType={"row-reverse"}
          >
            <div>
              {/* about card content */}
              <p>
                The vision is to help people connect with other individuals
                through movement and help them form real life connections.
                <br />
                <br />
                We envision a world where technology brings people together in
                the physical world, rather than keeping them apart. Where
                finding your community is as easy as opening an app.
              </p>
              {/* about dots */}
              <ul>
                <li>Connect with like-minded movers and adventurers nearby</li>
                <li>Discover inspiring activities and events that fuel your passion</li>
                <li>Foster a vibrant, healthy, and engaged community through movement</li>
              </ul>
            </div>
          </AboutCard>
        </div>
      </div>
      <Footer
        pageOn={'about'} />
    </div>
  );
};

export default About;
